<template>
  <div id="feedBackIndex" class="containerWarp">

    <div class="searchWarp flex_bet">
      <div class="searchBox">
        <el-input v-model="searchObj.content" :placeholder="$t('feedBack.Keyword')" class="searchInp" clearable
          @clear="changeSearch" @change="changeSearch" style="width: 240px;">
          <el-button slot="append" icon="el-icon-search" @click="changeSearch" />
        </el-input>
        <el-date-picker v-model="searchObj.selectDay" :end-placeholder="$t('AllDevices.endDate')"
          :range-separator="$t('AllDevices.to')" :start-placeholder="$t('AllDevices.startDate')" type="daterange"
          @change="changeSearch" />

        <!-- <SearchCompany v-model="selectCompany2" :value="selectCompany2" @change="changeSearch" /> -->
        <!-- 类型 -->
        <el-select v-model="searchObj.type" :placeholder="$t('AllDevices.Type')" clearable filterable
          @change="changeSearch">
          <el-option v-for="(item,index) in typeOptions" :key="index" :label="item.label" :value="item.key" />
        </el-select>
        <!-- 状态 -->
        <el-select v-model="searchObj.status" :placeholder="$t('AllDevices.Status')" clearable filterable
          @change="changeSearch">
          <el-option v-for="(item,index) in statusOptions" :key="index" :label="item.label" :value="item.key" />
        </el-select>
        
      </div>
      <el-button icon="el-icon-plus" :title="$t('titles.addQuestion')" type="primary" style="float: right;"
        @click="addFeed" />
    </div>
    <el-table v-loading="loadTable" :data="tableData" class="tableData" border>
      <el-table-column type="expand" style="border-right: none;">
        <template slot-scope="scope">
          <el-row :gutter="20" class="expand_box">
            <el-col :xs="8" :sm="8" :lg="8">
              <span>联系人</span>
              <span>{{ scope.row.createBy }}</span>
            </el-col>
            <el-col :xs="8" :sm="8" :lg="8">
              <span>{{$t('adminView.Tel')}}</span>
              <span>{{ scope.row.phoneNumber }}</span>

            </el-col>
            <el-col :xs="8" :sm="8" :lg="8">
              <span>{{$t('company.Email')}}</span>
              <span>{{ scope.row.email }}</span>
            </el-col>
            <el-col :xs="12" :sm="12" :lg="12">
              <span>URL</span>
              <span>{{ scope.row.sourceUrl }}</span>
            </el-col>
          </el-row>
        </template>
      </el-table-column>
      <el-table-column :label="$t('company.remark')" align="center" prop="content" width="300">
        <template slot-scope="scope" >
          <span v-if="scope.row.status==0" class="new">NEW</span>
          <span>{{ scope.row.content }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('AllDevices.Type')" align="center" prop="type">
        <template slot-scope="scope">
          {{typeName(scope.row.type)}}
        </template>
      </el-table-column>
      <el-table-column :label="'来源'" align="center" prop="source">
        <template slot-scope="scope">
          {{ sourceHandle(scope.row.source) }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('warningPage.CreatedAt')" align="center" prop="createTime" />
      <el-table-column v-if="haveChildCompany" :label="'公司'" align="center" prop="companyName" />
      <!-- <el-table-column :label="$t('QR.Uploader')" align="center" prop="createBy" />
      <el-table-column :label="$t('adminView.Tel')" align="center" prop="phoneNumber" /> -->
      <el-table-column :label="$t('AllDevices.Status')" align="center" prop="statusZh">
        <template slot-scope="scope">
          <div style="text-align: center;" class="basinfoStatu">
            <el-popover v-if="scope.row.status==0||scope.row.status==1" v-model="scope.row.showPopover"
              placement="bottom" width="auto" trigger="click" :popper-class="'statuPop'+scope.$index">
              <div>
                <div v-for="(item,index) in statusOptions" :key="index" class="statusOption">
                  <p v-if="item.key>=scope.row.status&&item.canSelect" class="statuSelect"
                    :class="{'activeStatu':item.isActive}" @click="selectStatu(scope.$index,item.key)">{{ item.label }}
                  </p>
                  <div v-if="item.isActive" class="el-icon-success" />
                </div>
                <div slot="footer" class="dialog-footer" style="text-align: center;margin-top:10px;">
                  <el-button class="filter-item" type="primary"
                    @click="submitEdit(scope.row.id,scope.row.editStatus)">{{ $t('button.Submit') }}</el-button>
                </div>
              </div>
              <div slot="reference"
                :class="{'doing':scope.row.status==0||scope.row.status==1,'done':scope.row.status==2,'overTime':scope.row.status==3||scope.row.status==4}">
                {{ scope.row.statusZh }}
              </div>
            </el-popover>
            <div v-else
              :class="{'doing':scope.row.status==0||scope.row.status==1,'done':scope.row.status==2,'overTime':scope.row.status==3||scope.row.status==4}">
              {{ scope.row.statusZh }}
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('yhubReport.Operating')" align="center" prop="action">
        <template slot-scope="scope">
          <div style="text-align: center;">
            <el-button icon="el-icon-view" :title="$t('titles.toDetail')" size="mini" type="primary"
              @click="gotoDetail(scope.row)" />
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 列表模块————分页 -->
    <div style="background-color: white;width: 100%;border-radius: 0 0 10px 10px;">
      <div class="pagination-container">
        <el-pagination v-if="pageshow" :page-size="listQuery.pageInfo.limit" :page-sizes="listQuery.pageInfo.pageList"
          :total="listQuery.pageInfo.total" background current-page.sync="listQuery.pageInfo.page"
          layout="total, sizes, prev, pager, next, jumper" @current-change="handleCurrentChange"
          @size-change="handleSizeChange" />
      </div>
    </div>
    <!-- 新增--弹窗 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="addPopShow" width="60%" class="pop">
      <el-form ref="addPop" :inline="false" :model="addPopObj" label-position="right" :rules="rules"
        label-width="200px">
        <el-row :gutter="40">
          <el-col :xs="24" :sm="24" :lg="12">
            <el-form-item :label="$t('AllDevices.Type')">
              <el-select v-model="addPopObj.type" :placeholder="$t('AllDevices.Type')" filterable>
                <el-option v-for="(item,index) in typeOptions" :key="index" :label="item.label" :value="item.key" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :lg="12">
            <el-form-item :label="$t('feedBack.AssociatedDevice')">
              <el-input v-model.trim="addPopObj.sn" :placeholder="$t('AllDevices.SearchDeviceSn')" class="searchInp"
                clearable @blur="snChange(addPopObj.sn)" />
              <p v-if="snNotFind" class="warnP">{{ $t('BondOrUpdateDevice.SNNotFound') }}</p>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :lg="12">
            <el-form-item :label="$t('company.Email')">
              <el-input v-model.trim="addPopObj.email" :placeholder="$t('company.Email')" class="searchInp" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :lg="12">
            <el-form-item :label="$t('company.Mobile')">
              <el-input v-model.trim="addPopObj.phoneNumber" :placeholder="$t('company.Mobile')" class="searchInp" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :lg="24">
            <el-form-item :label="$t('company.remark')" prop="content">
              <el-input v-model="addPopObj.content" :autosize="{ minRows: 4, maxRows: 8}"
                :placeholder="$t('warningSet.Pleaseenter')" style="width: 90%" type="textarea" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :lg="24">
            <el-form-item :label="$t('feedBack.image')">
              <upload-imgs v-model="fileList"></upload-imgs>
              <!-- <div class="imgWarp">
                <div v-for="(item,index) in apiImgList" :key="index" class="smallImgBox"
                  @mousemove="item.deleteImgBoxShow=true" @mouseleave="item.deleteImgBoxShow=false">
                  <img :src="item.url" alt="">
                  <div v-if="item.deleteImgBoxShow" class="deleteImgBox">
                    <i class="el-icon-zoom-in" @click="clickSmallImg(item.url)" />
                    <i class="el-icon-delete" @click="removeImg(item.url,index)" />
                  </div>
                </div>
                <el-upload ref="upload" class="upload-demo" :disabled="apiImgList.length>=5" action="#"
                  :on-change="handleChange" :show-file-list="false">
                  <div class="el-icon-plus uploadPlus" />
                </el-upload>
              </div> -->
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addPopShow = false">{{ $t('button.Cancel') }}</el-button>
        <el-button class="filter-item" type="primary" :disabled="disabledSubmit"
          @click="submitPop('addPop')">{{ $t('button.Submit') }}</el-button>
      </div>
    </el-dialog>
    <!-- <el-dialog :visible.sync="showBigContentImg">
      <img width="100%" :src="bigContentImgUrl" alt="bigContentImgUrl">
    </el-dialog> -->
  </div>
</template>

<script>
import { pagination } from '@/utils/init_table' // 分页
import { pageCustomerService, uploadImg, addCustomerService, checkSn, updateCustomerServiceStatus } from '@/api/feedBack'
import i18n from '@/i18n'
import { getDateAndHour } from '@/utils/updateTime.js'
import UploadImgs from './components/UploadImgs.vue'
import { mapState } from 'vuex'

export default {
  name: '',
  components: {
    UploadImgs
  },
  data () {
    return {
      fileList: [],
      tableData: [],
      statusOptions: [ // 状态：0未处理，1处理中，2已处理，3已过期,4作废
        { key: 0, label: i18n.t('feedBack.Untreated') },
        { key: 1, label: i18n.t('feedBack.Processing') },
        { key: 2, label: i18n.t('feedBack.Processed') },
        { key: 3, label: i18n.t('feedBack.expired') },
        { key: 4, label: i18n.t('feedBack.Void') }
      ],
      // 分页----start
      listQuery: {
        deviceVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow: true,
      // 分页----end
      oneWeek: [new Date().setHours(0, 0, 0, 0) - 6 * 24 * 60 * 60 * 1000, new Date().setHours(0, 0, 0) + 24 * 60 * 60 * 1000 - 1000], // 一周
      searchObj: {},
      loadTable: true,
      addPopShow: false,
      addPopObj: {
        type: 5
      },
      apiImgList: [], // 后台返回的地址
      uploadImgTime: 0, // 文件上传时间
      showBigContentImg: false,
      bigContentImgUrl: '',
      snNotFind: false,
      disabledSubmit: false,
      haveChildCompany: true, // 是否有子公司
      selectCompany: [],
      // selectCompany2: []

    }
  },
  computed: {
    ...mapState(['userInfo']),
    language () {
      return this.$store.state.language
    },
    typeOptions () { // 反馈类型：1硬件产品问题、2系统后台问题、3APP问题、4QR扫码、5其它
      return [
        { key: 1, label: i18n.t('feedBack.HardwareProblem') },
        { key: 2, label: i18n.t('feedBack.SystemProblem') },
        { key: 3, label: i18n.t('feedBack.APPProblem') },
        { key: 4, label: i18n.t('feedBack.QRProblem') },
        { key: 6, label: '官网咨询' },
        { key: 7, label: 'YHUB推广页咨询' },
        { key: 8, label: '展会推广' },
        { key: 5, label: i18n.t('feedBack.other') }
      ]
    },
    rules () {
      return {
        content: [{ required: true, message: i18n.t('lease.Cannotbeblanked2'), trigger: ['blur', 'change'] }]
      }
    }
  },
  watch: {
    language (newValue, oldValue) {
      this.queryList()
      this.statusOptions.forEach(v => {
        switch (v.key) {
          case 0: v.label = i18n.t('feedBack.Untreated'); break
          case 1: v.label = i18n.t('feedBack.Processing'); break
          case 2: v.label = i18n.t('feedBack.Processed'); break
          case 3: v.label = i18n.t('feedBack.expired'); break
          case 4: v.label = i18n.t('feedBack.Void'); break
        }
      })
    },
    tableData: {
      handler (newValue, oldValue) {
        this.tableData.forEach(v => {
          if (v.showPopover) {
            this.statusOptions.forEach(m => {
              m.isActive = false
              if (m.key == v.editStatus) {
                m.isActive = true
              }
            })
            this.statusOptions = [...this.statusOptions]
            // console.log('this.statusOptions--watch', this.statusOptions)
          }
        })
      },
      deep: true
    }
  },
  mounted () {
    if (this.$route.query.sn) this.searchObj.content = this.$route.query.sn
    this.statusOptions.forEach(v => {
      v.canSelect = true
      if (this.$store.state.companyId != 4 && !this.$store.state.isAdmin && (v.key == 1 || v.key == 3)) {
        v.canSelect = false
      }
    })
    this.statusOptions = [...this.statusOptions]
    this.queryList()
  },
  methods: {
    sourceHandle (val) {
      if (val == 1) return '管理后台'
      if (val == 2) return 'APP'
      if (val == 3) return '扫码H5'
      if (val == 4) return '云充官网'
      if (val == 5) return 'Yhub推广页'
      return '其他'
    },
    typeName (val) {
      const obj = this.typeOptions.find(item => item.key == val)
      if (obj) return obj.label
      return '其他'
    },
    queryList () {
      var param = {
        pageNum: this.listQuery.pageInfo.pageNum, // 分页--选中某一页
        pageSize: this.listQuery.pageInfo.pageSize, // 分页--每一页的列表的行数 10 20 50,
        startDate: null,
        endDate: null,
        companyIdList: this.selectCompany,
        content: this.searchObj.content,
        // createBy: this.userInfo.userLoginName,
        status: this.searchObj.status,
        type: this.searchObj.type
      }
      if (this.searchObj.selectDay && this.searchObj.selectDay.length > 0) {
        param.startDate = new Date(this.searchObj.selectDay[0]).setHours(0, 0, 0, 0)
        param.endDate = new Date(this.searchObj.selectDay[1]).setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000 - 1000
      }
      this.loadTable = true
      pageCustomerService(param).then(res => {
        console.log('问题反馈-分页', res)
        this.loadTable = false
        if (res.resultCode === 1001) {
          var list = res.resultModel.list || []
          this.listQuery.pageInfo.total = res.resultModel.total // 分页
          list.forEach(v => {
            if (v.createTime) v.createTime = getDateAndHour(new Date(v.createTime).getTime(), 'noSecond')
            v.isView = true
            v.editStatus = v.status
            v.showPopover = false
            this.statusOptions.forEach(m => {
              if (v.status == m.key) v.statusZh = m.label
            })
            // this.typeOptions.forEach(m => {
            //   if (v.type == m.key)v.typeZh = m.label
            // })
          })
          this.tableData = list
        }
      })
    },
    addFeed () { // 新增意见弹窗--打开
      this.addPopShow = true
      this.snNotFind = this.disabledSubmit = false
      for (var attr in this.addPopObj) this.addPopObj[attr] = ''
      this.addPopObj.type = 5
      this.$nextTick(() => {
        this.apiImgList = []
        // this.$refs.upload.clearFiles()
        this.$refs.addPop.clearValidate()
      })
    },
    snChange (val) { // 新增意见弹窗--校验sn是否正确
      if (val) {
        setTimeout(() => {
          if (/^[0-9]*$/.test(val)) { // sn都是数字（即为Yhub）才校验，其他不校验
            checkSn({ sn: val }).then((res) => {
              if (res.resultCode == 1001) {
                this.snNotFind = this.disabledSubmit = false
              } else {
                this.snNotFind = this.disabledSubmit = true
              }
            })
          } else {
            this.snNotFind = this.disabledSubmit = false
          }
        }, 1000)
      } else {
        this.snNotFind = this.disabledSubmit = false
      }
    },
    submitPop (formName) { // 新增意见弹窗--提交
      this.$refs[formName].validate((valid) => {
        if (valid && !this.isShowMustIntWarn) {
          var param = {
            'companyId': this.$store.state.companyId,
            'companyName': this.$store.state.companyName,
            'content': this.addPopObj.content,
            'email': this.addPopObj.email,
            'imgs': this.fileList.join(','),
            'sn': this.addPopObj.sn,
            'phoneNumber': this.addPopObj.phoneNumber,
            'source': 1, // 操作来源：1 后台， 2 app，3 扫码H5
            'type': this.addPopObj.type
          }
          this.disabledSubmit = true
          setTimeout(() => {
            this.disabledSubmit = false
          }, 5000)
          addCustomerService(param).then(res => {
            if (res.resultCode == 1001) {
              this.$message({
                type: 'success',
                message: i18n.t('warningSet.submitted')
              })
              this.addPopShow = false
              this.queryList()
            } else {
              this.$message({
                type: 'error',
                message: res.resultModel
              })
            }
          })
        }
      })
    },
    closeEdit (id) { // 列表中改状态--关闭
      this.tableData.forEach(v => {
        if (v.id == id) v.isView = true
      })
    },
    selectStatu (index, key) { // 列表中改状态--选中状态
      this.statusOptions.forEach(v => {
        v.isActive = false
        if (v.key == key) {
          v.isActive = true
          this.tableData[index].editStatus = v.key
        }
      })
      this.statusOptions = [...this.statusOptions]
      // console.log('this.statusOptions', this.statusOptions)
    },
    submitEdit (id, editStatus) { // 列表中改状态--提交
      var param = {
        'id': id,
        'status': editStatus
      }
      updateCustomerServiceStatus(param).then(res => {
        if (res.resultCode === 1001) {
          this.queryList()
        }
      })
    },
    gotoDetail (row) {
      var routeData = this.$router.resolve({
        path: '/feedBack/feedBackDetail',
        query: {
          id: row.id
        }
      })
      window.open(routeData.href, '_self')
    },
    changeSearch () { // 搜索
      // this.selectCompany = []
      // this.selectCompany2.forEach(v => {
      //   this.selectCompany.push((typeof v === 'string' && v.indexOf('ID') > -1) ? v.slice(2) : v)
      // })
      this.listQuery.pageInfo.pageNum = 1
      this.pageshow = false
      this.queryList()
      this.$nextTick(() => {
        this.pageshow = true
      })
    },
    change (e) {
      this.$forceUpdate()
    },
    // 分页----start
    handleSizeChange (val, e) { // 每一页的列表的行数 10 20 50
      this.listQuery.pageInfo.pageSize = val
      this.queryList()
    },
    handleCurrentChange (val, e) { // 选中某一页
      this.listQuery.pageInfo.pageNum = val
      this.queryList()
    }
    // 分页----end
  }
}
</script>

<style lang="scss" scoped>
#feedBackIndex {
  .searchWarp {
    margin-bottom: 15px;
  }
  .smallImgBox {
    width: 100px;
    display: inline-block;
    position: relative;
    margin: 0 5px;
    img {
      width: 100%;
    }
  }
  .imgWarp {
    .deleteImgBox {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      background: rgba(0, 0, 0, 0.4);
      display: flex;
      align-items: center;
      justify-content: center;
      i {
        color: #fff;
        font-size: 20px;
        margin: 10px;
        cursor: pointer;
      }
    }
  }
  .basinfoStatu {
    .doing,
    .done,
    .overTime {
      padding: 6px 20px;
      display: inline-block;
      line-height: 14px;
      border-radius: 15px;
      cursor: not-allowed;
    }
    .doing {
      color: #1990fc;
      border: 1px solid #1990fc;
      cursor: pointer;
    }
    .done {
      color: black;
      border: 1px solid black;
    }
    .overTime {
      color: #aaadb4;
      border: 1px solid #aaadb4;
    }
  }
  .statuInp {
    width: calc(100% - 70px);
    margin-right: 10px;
  }
  .statuSelect {
    margin-right: 10px;
    width: calc(100% - 140px);
  }
  .btnGroup {
    display: flex;
    margin-top: 10px;
    .upload-demo {
      margin-left: 10px;
    }
  }
  .warnP {
    color: red;
    line-height: 20px;
    margin-bottom: -5px;
  }
}

.new {
    color: red;
    padding: 5px;
    background: #ff00001f;
    word-break: keep-all;
    font-size: 12px;
    line-height: 12px;
  }
</style>
